<template>
  <main id="platform-admin-login">
    <section>
      <img :src="fluxooLogo" alt="Logo fluxoo doc">
      <h1>Painel interno Fluxoo. Acesso restrito à equipe.</h1>
      <form @submit="$event.preventDefault()" action="">
        <section>
          <label for="email">Digite seu e-mail  <strong>*</strong></label>
          <input autocomplete='off' v-model="loginForm.email" type="text" placeholder="ex: equipe@fluxoo.com.br" name="email" id="email">
        </section>
        <section>
          <label for="password">Digite sua senha  <strong>*</strong></label>
          <input autocomplete='off' v-model="loginForm.password" :type="showPassword ? 'text':'password'" placeholder="ex: 123456" name="password" id="password">
          <button type="button" @click="showPassword = !showPassword">
            <svg v-if="showPassword" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="vuesax/linear/eye">
              <g id="eye">
              <path id="Vector" d="M15.58 11.9999C15.58 13.9799 13.98 15.5799 12 15.5799C10.02 15.5799 8.41998 13.9799 8.41998 11.9999C8.41998 10.0199 10.02 8.41992 12 8.41992C13.98 8.41992 15.58 10.0199 15.58 11.9999Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path id="Vector_2" d="M12 20.2702C15.53 20.2702 18.82 18.1902 21.11 14.5902C22.01 13.1802 22.01 10.8102 21.11 9.40021C18.82 5.80021 15.53 3.72021 12 3.72021C8.47003 3.72021 5.18003 5.80021 2.89003 9.40021C1.99003 10.8102 1.99003 13.1802 2.89003 14.5902C5.18003 18.1902 8.47003 20.2702 12 20.2702Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              </g>
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M14.5299 9.46992L9.46992 14.5299C8.81992 13.8799 8.41992 12.9899 8.41992 11.9999C8.41992 10.0199 10.0199 8.41992 11.9999 8.41992C12.9899 8.41992 13.8799 8.81992 14.5299 9.46992Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M17.8198 5.76998C16.0698 4.44998 14.0698 3.72998 11.9998 3.72998C8.46984 3.72998 5.17984 5.80998 2.88984 9.40998C1.98984 10.82 1.98984 13.19 2.88984 14.6C3.67984 15.84 4.59984 16.91 5.59984 17.77" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.41992 19.5299C9.55992 20.0099 10.7699 20.2699 11.9999 20.2699C15.5299 20.2699 18.8199 18.1899 21.1099 14.5899C22.0099 13.1799 22.0099 10.8099 21.1099 9.39993C20.7799 8.87993 20.4199 8.38993 20.0499 7.92993" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15.5099 12.7C15.2499 14.11 14.0999 15.26 12.6899 15.52" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9.47 14.53L2 22" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M21.9998 2L14.5298 9.47" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </section>
        <div class="recaptcha" style="display: flex; justify-content: center; margin: 16px 0 15px 0">
          <Recaptcha :sitekey="recaptchaConfig.sitekey" :callback="(token) => loginForm.token = token" />
        </div>
        <input autocomplete='off' :disabled="!(loginForm.email && loginForm.password)" @click="login" type="button" value="entrar">
      </form>
    </section>
  </main>
  <Loader v-if="isPerformingRequest" :zIndex="99"/>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import { isPerformingRequest, useAxios } from '@/api/axios'
import router from '@/router'
import Loader from '@/components/loader/Loader.vue'
import Recaptcha from '@/components/google/Recaptcha.vue'
import { recaptchaConfig } from '@/global/config/recaptcha'
import fluxooLogo from '@/assets/images/fluxoo-doc-logo.png'

const showPassword = ref<boolean>(false)
const loginForm = ref<{email?:string, password?:string, token?: string}>({})
const axios = useAxios()

async function login () {
  axios.post('/api/platform-admin/login', loginForm.value)
    .then(() => {
      router.push({ name: 'platform-admin.dashboard' })
    })
}
</script>

<style lang="scss">
  #platform-admin-login{
    min-height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--VERDE-BACKGROUND, #F5F8F7);
    section{
      &:first-child{
        width: 100%;
        max-width: 455px;
        border-radius: 28px;
        margin: 45px 15px;
        background: var(--branco, #FFF);
        animation: enterContent ease .4s;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 34px;
        padding-top: 43px;
        box-sizing: border-box;
        img{
          width: 195px;
          min-width: 111px;
          height: 58px;
        }
        h1{
          color: var(--cinza-forte, #6F6F6F);
          text-align: center;
          font-family: Inter;
          font-size: 16px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          letter-spacing: 0.8px;
        }
        form{
          display: flex;
          flex-direction: column;
          width: 100%;
          margin: 40px 0 0 0;
          section{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: start;
            position: relative;
            background-image: unset;
            box-sizing: border-box;
            &:first-child{
              margin: 0 0 24px 0;
            }
            label{
              color: #090909;
              font-family: 'Inter', sans-serif;
              font-size: 16px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;
              margin: 0 0 8px 0;
              strong{
                color: #EB1320;
                font-weight: 600;
              }
            }
            input{
              width: 100%;
              height: 55px;
              padding: 0 18px;
              border-radius: 16px;
              border: none;
              background: #F5F5F5;
              box-sizing: border-box;
              color: #090909;
              font-family: 'Inter', sans-serif;
              font-size: 18px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
              &::placeholder{
                color: #090909;
                font-family: 'Inter', sans-serif;
                font-size: 18px;
                font-style: normal;
                font-weight: 400;
              }
              &:focus{
                outline: none;
                color: $fluxoo-primary-color;
                &::placeholder{
                  color: transparent;
                }
                & ~ button{
                  svg{
                    stroke: $fluxoo-primary-color !important;
                  }
                }
              }
            }
            button{
              width: 24px;
              min-width: 24px;
              height: 24px;
              min-height: 24px;
              display: flex;
              align-items: center;
              justify-content: center;
              position: absolute;
              bottom: 15px;
              right: 20px;
            }
            svg{
              width: 24px;
              min-width: 24px;
              height: 24px;
              min-height: 24px;
              stroke: #090909;
              transition: stroke .2s;
              cursor: pointer;
              &:hover{
                stroke: $fluxoo-primary-color;
              }
            }
          }
          input[type='button']{
            width: 100%;
            height: 60px;
            border: none;
            border-radius: 30px;
            background: $fluxoo-primary-color;
            color: #FFF;
            text-align: center;
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 800;
            line-height: 18px;
            transition: background .2s;
            cursor: pointer;
            &:hover{
              background: $fluxoo-primary-color-hover;
            }
            &:disabled{
              background: #F1F1F1 !important;
              color: #6F6F6F !important;
              cursor: not-allowed !important;
            }
          }
        }
      }
    }
  }
</style>
